import axios from "axios";
import baseURL from "../../Config";
export const params = (values = {}) =>
  new URLSearchParams(
    Object.entries(values).filter(
      ([, v]) => v !== "" && v !== undefined && v !== null
    )
  ).toString();
export async function api(path, method = "GET", data, query, download = false) {
  const stored = JSON.parse(
    localStorage.getItem("adminUser") ||
      localStorage.getItem("userDetails") ||
      "{}"
  );
  const token = stored?.data?.token || stored?.data?.accessToken;
  try {
    const response = await axios({
      url: `${baseURL}despacho-insumos/${path}${
        query ? "?" + params(query) : ""
      }`,
      method,
      data,
      headers: { Authorization: `Bearer ${token}` },
      ...(download ? { responseType: "blob" } : {}),
    });
    if (!download) return response.data.data;
    const url = URL.createObjectURL(response.data),
      link = document.createElement("a");
    link.href = url;
    link.download = `despacho-${path.split("/").pop()}.xlsx`;
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) {
    let body = error.response?.data;
    if (body instanceof Blob) {
      try {
        body = JSON.parse(await body.text());
      } catch (_) {
        body = null;
      }
    }
    throw Object.assign(
      new Error(
        body?.message || "No se pudo completar la operación. Intente de nuevo."
      ),
      {
        confirmation: body?.data?.confirmation,
        details: body?.data,
        status: error.response?.status,
      }
    );
  }
}
export async function confirmedWrite(path, method, body, confirm) {
  const input = { ...body };
  for (;;) {
    try {
      return await api(path, method, input);
    } catch (error) {
      if (
        !["confirmOldDate", "confirmExcessReturn"].includes(
          error.confirmation
        ) ||
        input[error.confirmation] ||
        !confirm ||
        !(await confirm(error))
      )
        throw error;
      input[error.confirmation] = true;
    }
  }
}
